export const extractSlug = (domain: string): string => {
  if (domain.includes('vgs-e2e-tests') || import.meta.env.VITE_E2E) {
    return 'vgs-e2e-tests';
  }

  return domain.split('.')[0];
};
